import { render, staticRenderFns } from "./filtersHandler.vue?vue&type=template&id=020af6e7&"
import script from "./filtersHandler.vue?vue&type=script&lang=js&"
export * from "./filtersHandler.vue?vue&type=script&lang=js&"
import style0 from "./filtersHandler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports